export const environment = {
  endpoint: 'https://api-interticket.abostudio.mx/',
  production: false,
  storage: 'interticket',
  title: 'Interticket',
};
